export interface StorageAdapter {
  // Messages
  getMessages(conversationId: string, limit?: number): Promise<any[]>;
  saveMessages(conversationId: string, messages: any[]): Promise<void>;

  // Conversations
  getConversations(accountId: string): Promise<any[]>;
  saveConversations(accountId: string, conversations: any[]): Promise<void>;

  // Contacts/Users
  getContacts(accountId: string): Promise<any[]>;
  saveContacts(accountId: string, users: any[]): Promise<void>;

  // Accounts
  getAccounts(): Promise<any[]>;
  saveAccounts(accounts: any[]): Promise<void>;

  // Cache management
  getCacheSize(): Promise<number>;
  clearCache(): Promise<void>;
}

function sanitizeLocalAttachmentForStorage(attachment: any) {
  if (!attachment || typeof attachment !== "object") return attachment;
  const previewUrl = typeof attachment.preview_url === "string"
    ? attachment.preview_url
    : null;
  return {
    ...attachment,
    preview_url:
      previewUrl && previewUrl.startsWith("blob:")
        ? null
        : previewUrl,
  };
}

export function sanitizeMessagesForStorage(messages: any[]): any[] {
  return messages.map((message) => {
    const localAttachments = Array.isArray(message?.metadata?.local_attachments)
      ? message.metadata.local_attachments.map(sanitizeLocalAttachmentForStorage)
      : null;
    if (!localAttachments) return message;
    return {
      ...message,
      metadata: {
        ...(message.metadata ?? {}),
        local_attachments: localAttachments,
      },
    };
  });
}

class NoopStorageAdapter implements StorageAdapter {
  async getMessages() { return []; }
  async saveMessages() {}
  async getConversations() { return []; }
  async saveConversations() {}
  async getContacts() { return []; }
  async saveContacts() {}
  async getAccounts() { return []; }
  async saveAccounts() {}
  async getCacheSize() { return 0; }
  async clearCache() {}
}

let _adapter: StorageAdapter | null = null;

export function initStorage(adapter: StorageAdapter) {
  _adapter = adapter;
}

export function getStorage(): StorageAdapter {
  if (!_adapter) _adapter = new NoopStorageAdapter();
  return _adapter;
}
